import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { COMPANY_INFO, CORE_SERVICES, MAIN_AREAS } from '../data/siteData';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet"
        description="Beklager, siden du leder efter findes ikke eller er blevet flyttet. Find hjælp her."
      />

      <section className="py-20 sm:py-28 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-20 h-20 bg-[#fbf2ec] text-[#b45309] rounded-full flex items-center justify-center mx-auto mb-6 text-3xl">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
        </div>

        <span className="text-xs font-bold text-[#b45309] bg-[#fbf2ec] px-3.5 py-1.5 rounded-full inline-block mb-3">
          Fejl 404
        </span>

        <h1 className="text-3xl sm:text-5xl font-bold text-[#102419] mb-4">
          Beklager, siden blev ikke fundet
        </h1>

        <p className="text-base sm:text-lg text-[#3d5044] mb-8 max-w-xl mx-auto">
          Siden du leder efter findes ikke eller er blevet flyttet som led i vores nye hjemmesidestruktur. Benyt venligst et af linkene herunder for at finde det, du søger:
        </p>

        {/* Quick Nav Options */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto mb-10 text-left">
          <Link
            to="/"
            className="p-5 rounded-2xl bg-white border border-[#dce5df] hover:border-[#2d6a4f] shadow-2xs hover:shadow-xs transition-all group"
          >
            <i className="fa-solid fa-house text-[#2d6a4f] text-lg mb-2 block" aria-hidden="true" />
            <h3 className="font-bold text-[#14291d] group-hover:text-[#2d6a4f] transition-colors text-sm">
              Gå til forsiden
            </h3>
            <p className="text-xs text-[#5a7062] mt-1">Tilbage til hovedsiden</p>
          </Link>

          <Link
            to="/services"
            className="p-5 rounded-2xl bg-white border border-[#dce5df] hover:border-[#2d6a4f] shadow-2xs hover:shadow-xs transition-all group"
          >
            <i className="fa-solid fa-tree text-[#2d6a4f] text-lg mb-2 block" aria-hidden="true" />
            <h3 className="font-bold text-[#14291d] group-hover:text-[#2d6a4f] transition-colors text-sm">
              Se vores ydelser
            </h3>
            <p className="text-xs text-[#5a7062] mt-1">Træfældning, topkapning mv.</p>
          </Link>

          <Link
            to="/omraader"
            className="p-5 rounded-2xl bg-white border border-[#dce5df] hover:border-[#2d6a4f] shadow-2xs hover:shadow-xs transition-all group"
          >
            <i className="fa-solid fa-map-location-dot text-[#2d6a4f] text-lg mb-2 block" aria-hidden="true" />
            <h3 className="font-bold text-[#14291d] group-hover:text-[#2d6a4f] transition-colors text-sm">
              Områder vi dækker
            </h3>
            <p className="text-xs text-[#5a7062] mt-1">Kolding, Vejle, Aarhus mv.</p>
          </Link>
        </div>

        {/* Contact and phone action */}
        <div className="bg-[#f2f7f4] rounded-2xl p-6 sm:p-8 border border-[#cfe0d6] max-w-xl mx-auto">
          <h3 className="text-base font-bold text-[#14291d] mb-2">Har du brug for akut hjælp?</h3>
          <p className="text-sm text-[#4c6254] mb-5">
            Du kan altid kontakte os direkte eller ringe til os. Vi står klar alle ugens dage.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-[#1b4332] text-white font-semibold text-sm hover:bg-[#143627] transition-colors whitespace-nowrap text-center"
            >
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span className="whitespace-nowrap">Ring {COMPANY_INFO.phone}</span>
            </a>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border border-[#2d6a4f] text-[#1b4332] font-semibold text-sm hover:bg-white transition-colors text-center"
            >
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
